import { useSanityQuery } from '#imports';
import { getQuery as getOtherNewsQuery } from '~/groq-queries/other-news';

export async function useFetchOtherNews({ slug, newsItem } = {}) {
  const needOtherNewsFilterByTag = newsItem.value.isOtherNewsByTag;

  let otherNewsParams = { slug };

  if (needOtherNewsFilterByTag) {
    const newsItemTagNames = newsItem.value.tags?.map(({ name }) => name);
    otherNewsParams = { ...otherNewsParams, tags: newsItemTagNames };
  }

  const otherNewsQuery = getOtherNewsQuery(otherNewsParams);

  const response = await useSanityQuery(otherNewsQuery);
  return response;
}
